import type { SimpleKeyboard } from 'react-simple-keyboard';
import { SPECIAL_KEYS } from '../utils/constants';
import { KeyboardModule } from 'components/Keyboard/types';

export const syncShiftTheme = (keyboard: SimpleKeyboard) => {
  const isShiftActive = keyboard.getOptions().layoutName === 'shift';
  keyboard[isShiftActive ? 'addButtonTheme' : 'removeButtonTheme'](SPECIAL_KEYS.SHIFT, 'active');
};

function shiftLock(keyboard: SimpleKeyboard) {
  keyboard.registerModule('shiftLock', (module: KeyboardModule) => {
    module.fn = { handleButtonClicked: keyboard.handleButtonClicked };

    // Modules are (re)loaded each time the keyboard initializes (e.g. on every open), so this
    // re-syncs the shift highlight with the current layout: the instance can be reused across
    // opens where the layout resets to default but a stale "active" theme would persist.
    syncShiftTheme(keyboard);

    keyboard.handleButtonClicked = (...args) => {
      const [button] = args;
      if (button === SPECIAL_KEYS.SHIFT) {
        const { layoutName } = keyboard.getOptions();
        keyboard.setOptions({ layoutName: layoutName === 'default' ? 'shift' : 'default' });
        syncShiftTheme(keyboard);
      }
      module.fn.handleButtonClicked.call(keyboard, ...args);
    };
  });
}

export default shiftLock;
